// Centralized public runtime config.
// All values below are PUBLIC (Supabase URL, Supabase ANON key, public backend URL,
// Turnstile SITE key) and safe to ship in the frontend bundle. Any REACT_APP_* env
// var set at build time wins over these defaults.

export const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL ||
  "https://xpanripnupsfdvfkpxzm.supabase.co";

export const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhwYW5yaXBudXBzZmR2ZmtweHptIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQ4MTM4NjUsImV4cCI6MjEwMDM4OTg2NX0.KLXzk2_-kHgfl5RwFHow4YqhEXinwaKuTKyAEx3aeZ8";

export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  "https://instagram-esh5.onrender.com";

export const TURNSTILE_SITE_KEY =
  process.env.REACT_APP_TURNSTILE_SITE_KEY ||
  "0x4AAAAAAD8I79TtRZEK9XmA";
